import { ErrorBox } from "@metriport/shared-internal";

export default function ClientIdErrorPage() {
  // TODO 2188 Link docs
  return <ErrorBox>No Client ID found within the Metriport Canvas plugin configuration.</ErrorBox>;
}
